import React from 'react';
import { Chart } from 'react-chartjs-2';
import SelectBox from '../../components/SelectBox';
import NoChartData from './NoChartData';
import classes from './dashboard.module.css';

const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      beginAtZero: true,
      display: true,
      grid: {
        drawOnChartArea: false,
      },
      ticks: {
        font: {
          size: 9,
        },
      },
    },
    y: {
      display: false,
      grid: {
        drawOnChartArea: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
      position: 'top',
    },
    title: {
      display: false,
      text: 'Re-admission rate in 2022',
    },
    datalabels: {
      display: false,
    },
  },
};

// const labels = [
//   '192.168.1.1',
//   '192.168.1.1',
//   '192.168.1.1',
//   '192.168.1.1',
//   '192.168.1.1',
//   '192.168.1.1',
//   '192.168.1.1',
//   '192.168.1.1',
//   '192.168.1.1',
//   '192.168.1.1',
// ];

// const data = {
//   labels,
//   datasets: [
//     {
//       type: 'line',
//       fill: false,
//       label: 'Destinations',
//       data: [200, 450, 178, 264, 504, 421, 368, 102, 60, 670],
//       borderWidth: 2,
//       tension: 0.5,
//       pointBackgroundColor: 'rgba(109, 109, 109, 1)',
//       pointBorderColor: 'rgba(109, 109, 109, 1)',
//     },
//   ],
// };

function createGradient(ctx, area) {
  const colorStart = 'rgba(192, 20, 18, 1)';
  const colorMid = 'rgba(2192, 20, 18, 0.9)';
  const colorEnd = 'rgba(255, 122, 0, 1';

  const gradient = ctx.createLinearGradient(0, area.top, 0, area.bottom);
  // const gradient = ctx.createLinearGradient(area.left, 0, area.right, 0);

  gradient.addColorStop(0, colorStart);
  gradient.addColorStop(0.5, colorMid);
  gradient.addColorStop(1, colorEnd);

  return gradient;
}

const DestinationPort = (props) => {
  const { 
    topValueDestinationPort, 
    setTopValueDestinationPort, 
    dataSource,
    loading = false
  } = props.data;

  const chartRef = React.useRef(null);
  const [chartData, setChartData] = React.useState({
    datasets: [],
  });
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    const labels = [];
    const data = [];
    if (dataSource && dataSource.length > 0) {
      dataSource.forEach((d) => {
        if (d.length > 0) {
          labels.push(d[0]);
          data.push(d[1]);
        }
      });
    }
    setData({
      labels,
      datasets: [
        {
          type: 'line',
          fill: false,
          label: 'Destinations',
          data,
          borderWidth: 2,
          tension: 0.5,
          pointBackgroundColor: 'rgba(109, 109, 109, 1)',
          pointBorderColor: 'rgba(109, 109, 109, 1)',
        },
      ],
    });
  }, [dataSource]);

  React.useEffect(() => {
    const chart = chartRef.current;

    if (!chart || Object.keys(data).length === 0) {
      return;
    }

    const chartData = {
      ...data,
      datasets: data.datasets.map((dataset) => ({
        ...dataset,
        borderColor: createGradient(chart.ctx, chart.chartArea),
      })),
    };

    setChartData(chartData);
  }, [data]);

  return (
    <div className={classes.dest_ports}>
      <div className={classes.card_heading}>
        <div className={classes.card_heading_left}>
          <h3 className={classes.card_heading_text}>
            Top {topValueDestinationPort}
            {loading && <span className={classes.loadingIndicator}> (Loading...)</span>}
          </h3>
          <p className={classes.card_heading_subtext}>Destination Ports</p>
        </div>
        <SelectBox
          style={{ width: '20rem' }}
          value={topValueDestinationPort}
          onChange={(e) => setTopValueDestinationPort(e.target.value)}
          disabled={loading}
        >
          <option value={10}>Top 10 Ports</option>
          <option value={20}>Top 20 Ports</option>
          <option value={30}>Top 30 Ports</option>
        </SelectBox>
      </div>
      <div className={classes.chart_box}>
        {loading ? (
          <div className={classes.loadingOverlay}>
            <div className={classes.loadingSpinner}></div>
          </div>
        ) : dataSource && dataSource.length > 0 ? (
          <Chart ref={chartRef} type='bar' data={chartData} options={options} />
        ) : (
          <NoChartData />
        )}
      </div>
    </div>
  );
};

export default DestinationPort;
